import React from 'react';
import '../styles/Gallery.css';
// import doctors from '../images/gallery/doctors.jfif';
import doctors1 from '../images/WhatsApp Image 2024-03-14 at 10.07.37 PM.jpeg';
import doctors2 from '../images/WhatsApp Image 2024-03-14 at 10.07.40 PM (3).jpeg';
import doctors3 from '../images/WhatsApp Image 2024-03-14 at 10.07.40 PM (1).jpeg';

const Gallery = () => {
  return (
    <div className="gallery">
      <div className="gallery-heading">
        <h1 className="gallery-heading-1">
          Witness the Essence of Healing
        </h1>
        <h1 className="gallery-heading-2">
          Experience the Power of Ayurveda
        </h1>
      </div>
      <div className="gallery-main-heading">
        <h1>Gallery</h1>
      </div>

      <div className="gallery-container">
        <div className="gallery-content">
          <div className="gallery-content-image">
            <img src={doctors1} alt="doctor" />
          </div>
          <div className="gallery-content-text">
            <div className="text-head">
              Ayurvedic Consultation Session
            </div>
            <div className="text-description">
              Experience personalized Ayurvedic consultations with our expert doctors, guiding you towards holistic well-being.
            </div>
          </div>
        </div>
        <div className="gallery-content">
          <div className="gallery-content-text">
            <div className="text-head">
              Panchakarma Therapy
            </div>
            <div className="text-description">
              Discover the rejuvenating effects of Panchakarma therapy, a cornerstone of Ayurvedic healing, offered at ATHARV Multispeciality Clinic.
            </div>
          </div>
          <div className="gallery-content-image">
            <img src={doctors2} alt="doctor" />
          </div>
        </div>
        <div className="gallery-content">
          <div className="gallery-content-image">
            <img src={doctors3} alt="doctor" />
          </div>
          <div className="gallery-content-text">
            <div className="text-head">
              Ayurvedic Wellness Retreat
            </div>
            <div className="text-description">
              Immerse yourself in an Ayurvedic wellness retreat, where you'll experience holistic healing amidst serene surroundings.
            </div>
          </div>
        </div>
        {/* <div className="gallery-content">
          <div className="gallery-content-text">
            <div className="text-head">
              Yoga and Meditation Classes
            </div>
            <div className="text-description">
              Join our yoga and meditation classes to harmonize your body, mind, and soul, under the guidance of experienced instructors.
            </div>
          </div>
          <div className="gallery-content-image">
            <img src={doctors} alt="doctor" />
          </div>
        </div>
        <div className="gallery-content">
          <div className="gallery-content-image">
            <img src={doctors} alt="doctor" />
          </div> */}
          {/* <div className="gallery-content-text">
            <div className="text-head">
              Ayurvedic Cooking Workshop
            </div>
            <div className="text-description">
              Learn the art of Ayurvedic cooking and nutrition in our workshops, promoting health and vitality through balanced meals.
            </div>
          </div> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default Gallery;
